var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.415,
    height: 21.702,
    viewBox: "0 0 24.415 21.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-triangle",
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M24.143,18.65,13.973,1.017a2.035,2.035,0,0,0-3.525,0L.278,18.65A2.036,2.036,0,0,0,2.04,21.7H22.381A2.036,2.036,0,0,0,24.143,18.65Zm-11.933.339a1.356,1.356,0,1,1,1.356-1.356A1.356,1.356,0,0,1,12.21,18.989ZM13.831,8.884l-.543,5.425a.678.678,0,0,1-.675.611h-.805a.678.678,0,0,1-.675-.611l-.543-5.425a.678.678,0,0,1,.673-.746h1.892a.678.678,0,0,1,.675.746Z",
    transform: "translate(0)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M252.251,192h-1.892a.678.678,0,0,0-.675.746l.543,5.425a.678.678,0,0,0,.675.611h.805a.678.678,0,0,0,.675-.611l.543-5.425a.678.678,0,0,0-.673-.746Zm-.946,8.138a1.356,1.356,0,1,0,1.356,1.356A1.356,1.356,0,0,0,251.3,200.138Z",
    transform: "translate(-239.094 -183.862)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.b637876b16f93eed8be699c4a867f973.svg";
export { ForwardRef as ReactComponent };